import React, { useEffect, useRef, useState } from "react";
import { IoMenu } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import { NavLink, useNavigate } from "react-router-dom";
import { clearUser, selectUser } from "../../redux/authSlice";
import profile from "../../asset/profile.png";
import { AiOutlineLogout } from "react-icons/ai";
import { toast } from "react-toastify";
import { useLogoutMutation } from "../../redux/userApi";

const sidebarlist = [
  {
    name: "Banners",
    path: "/icon/banners.svg",
    link: "/banners",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Projects",
    path: "/icon/Projects.svg",
    link: "/projects",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Housing Societies",
    path: "/icon/Housing Scocieties.svg",
    link: "/housing-societies",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Blogs",
    path: "/icon/Blogs.svg",
    link: "/blogs",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Add User",
    path: "/icon/add user 1.svg",
    link: "/users",
    allowedRoles: ["admin"],
  },
  {
    name: "Press Release",
    path: "/icon/Press Release.svg",
    link: "/press-release",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Careers",
    path: "/icon/Careers.svg",
    link: "/careers",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Tenders",
    path: "/icon/Tenders.svg",
    link: "/tenders",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Media",
    path: "/icon/Media.svg",
    link: "/media",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Downloads",
    path: "/icon/Downloads.svg",
    link: "/downloads",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Announcement",
    path: "/icon/Announcement.svg",
    link: "/announcement",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Public Notices",
    path: "/icon/publicNotice.svg",
    link: "/public-notices",
    allowedRoles: ["admin", "mediaTeam"],
  },
  {
    name: "Setting",
    path: "/icon/setting.svg",
    link: "/update-profile",
    allowedRoles: ["admin", "mediaTeam"],
  },
];
const MobileNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);
  const user = useSelector(selectUser);
  const sidebarRef = useRef(null);
  const [logout, { isLoading }] = useLogoutMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && sidebarRef.current) {
      sidebarRef.current.scrollTop = 0;
    }
  }, [isOpen]);
  const userRole = useSelector((state) => state.auth.user?.role);
  const visibleLinks = sidebarlist.filter((item) =>
    item.allowedRoles.includes(userRole)
  );

  useEffect(() => {
    const handler = (event) => {
      if (!event.target.closest(".sidebar") && isOpen) {
        setTimeout(() => {
          setIsOpen(false);
        }, 300);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      const response = await logout().unwrap();
      if (response.success) {
        toast.success("User logged out successfully.");
        dispatch(clearUser());
        navigate("/login");
      }
    } catch (err) {
      console.error("Logout error:", err);
      toast.error(err.data.message);
    }
  };

  return (
    <>
      <div
        onClick={toggleSidebar}
        className="p-1.5 bg-[#00643b] md:hidden flex rounded-md text-white cursor-pointer"
      >
        <IoMenu />
      </div>
      <div
        className={`${
          isOpen ? "fixed inset-0 z-50 bg-black bg-opacity-50" : ""
        }`}
        onClick={() => setIsOpen(false)}
      >
        <div
          ref={sidebarRef}
          className={`fixed z-10 top-0 left-0 h-full  w-60 overflow-y-auto custom-scroll bg-white text-[#555555] transform ${
            isOpen ? "translate-x-0" : "-translate-x-full hidden"
          } transform transition-transform duration-300 ease-in-out scroll-smooth  sidebar`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className=" p-2 overflow-y-auto custom-scroll">
            <div className="flex flex-col w-full h-max">
              <div className="flex gap-2 w-full items-center">
                <img
                  src={user?.profile ? user?.profile : profile}
                  className=" w-10 rounded-lg"
                  alt=""
                />
                <div className="flex flex-col">
                  <span className="flex items-center font-medium text-[14px] text-[#151D48] capitalize">
                    {user?.name ? user?.name : "username"}
                    <div className=" relative">
                      {/* {open && (
                  <div
                    className="absolute right-0 z-30 mt-0 w-max p-2 origin-top-right rounded-md bg-[#fff] shadow-lg "
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className=" flex flex-col items-start gap-2 p-1 text-sm font-medium"> */}
                      {/* <button
                        disabled
                        className={`flex items-center gap-2 p-1.5 hover:bg-[#efefef] w-full rounded-lg `}
                      >
                        <FaRegUserCircle className=" size-6 text-[#00643b]" />{" "}
                        Update Profile
                      </button> */}
                      {/* <button
                        onClick={() => {
                          setOpen(false);
                          setIsPasswordModalOpen(true);
                        }}
                        className={`flex items-center gap-2  p-1.5 hover:bg-[#efefef] w-full rounded-lg`}
                      >
                        <RiLockPasswordLine className=" size-6 text-[#00643b]" />
                        Change Password
                      </button> */}

                      {/* <p className="  rounded border-t w-full border-[#00643b]"></p> */}
                      {/* <button
                        onClick={() => handleLogout()}
                        disabled={isLoading ? true : false}
                        className={`flex items-center gap-2 p-1.5 hover:bg-[#efefef] w-full rounded-lg `}
                      >
                        <AiOutlineLogout className=" size-6 text-[#00643b]" />
                        Logout
                      </button> */}
                      {/* </div>
                  </div>
                )} */}
                    </div>
                  </span>
                  <span className="text-[#737791] text-[12px] capitalize">
                    {user?.role ? user?.role : "role"}
                  </span>
                </div>
              </div>

              <div className="flex flex-col mt-3 w-full ">
                {visibleLinks.map((list, i) => (
                  <NavLink
                    to={list.link}
                    key={i}
                    className={({ isActive }) =>
                      `flex items-center gap-2 px-3 py-2 rounded-xl  text-[.9rem] font-medium transition-all ${
                        isActive
                          ? "bg-[#00643b] text-white"
                          : "text-[#666666] hover:bg-[#f3f3f3]"
                      }`
                    }
                  >
                    <ReactSVG src={list.path} className={`w-5`} />
                    <span>{list.name}</span>
                  </NavLink>
                ))}
              </div>
              <button
                onClick={() => handleLogout()}
                disabled={isLoading ? true : false}
                className={`flex items-center gap-2 px-3 py-2  text-[.9rem] font-medium text-[#666666]  w-full ${
                  isLoading ? "cursor-not-allowed" : ""
                }  `}
              >
                <AiOutlineLogout className=" size-5" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNavbar;
